// extracted by mini-css-extract-plugin
export var inHeader = "search-module--inHeader--7e9d1";
export var inSideBar = "search-module--inSideBar--69c02";
export var input = "search-module--input--eebe6";
export var missingImage = "search-module--missingImage--d3703";
export var result = "search-module--result--5f6a0";
export var resultHighlighted = "search-module--resultHighlighted--219ae";
export var resultImage = "search-module--resultImage--54a7b";
export var resultText = "search-module--resultText--4a784";
export var resultsList = "search-module--resultsList--9f3e5";
export var search = "search-module--search--d848b";
export var searchIcon = "search-module--searchIcon--f8aee";